import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import Button from "components/CustomButtons/Button.js";
import Tooltip from "@mui/material/Tooltip";
import Add from "@mui/icons-material/Add";

import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

import styles from "../ServicesSections.module.scss";
export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  return (
    <div className={classes.section} style={{ padding: "0px" }}>
      <GridContainer justifyContent="center">
        <GridItem
          xs={12}
          sm={10}
          md={10}
          style={{ paddingLeft: "30px", paddingRight: "30px" }}
        >
          <h2 className={classes.title}>
            What's included in our Google Ads package?
          </h2>
          <p>You will receive a complete Google Ads campaign setup, which includes:</p>
          <ul>
            <li>Competitor Analysis</li>
            <li>Conversion Optimisation</li>
            <li>Complete Management Of Your Account</li>
            <li>Keyword Research & Optimization</li>
            <li>Outstanding Ad Copy</li>
            <li>Enhance Ads With Ad Extensions</li>
            <li>Device Optimization</li>
            <li>Bid Management</li>
            <li>
              Negative Keyword Implementation To Exclude Irrelevant Traffic
            </li>
            <li>
              Reporting In a Professional PDF and Your Own Personal Dashboard
              (see here for demo)
            </li>
          </ul>
          <Quote
            textClassName={classes.quoteText}
            text="“The work completed for Prezzee has not only improved the analytics and tagging functions, but also had a positive impact of user experience as well as improvements to Prezzee’s back end processes.”"
            author="Renee Gangemi, Director at The Marketing Equation / Prezzee"
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
